import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: string | null, part: 'full' | 'date' | 'time' = 'full'): string {
    if (!value) return '-';

    const date = new Date(value);
    if (isNaN(date.getTime())) return value;

    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const year = date.getFullYear();
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);

    if (part === 'date') {
      return `${month}-${day}-${year}`;
    }

    if (part === 'time') {
      return `${hours}:${minutes}:${seconds}`;
    }

    return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
  }

}
